import { spawn } from 'redux-saga/effects';
import watchSubmitSeniorAuth from './submitSeniorAuth';
import watchGetPrimaryRecord from './getPrimaryRecord';

export default function* seniorAuthSaga() {
  yield spawn(watchSubmitSeniorAuth);
  yield spawn(watchGetPrimaryRecord);
}
